export const categories = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-kakao-talk-fill', description: '韩国漫画精选，画风精美剧情引人入胜', color: 'accent' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-fill', description: '日本漫画经典，热血与细腻并存', color: 'primary' },
  { slug: 'guoman', name: '国漫', icon: 'ri-china-railway-fill', description: '国产漫画崛起，创意无限精彩纷呈', color: 'secondary' },
  { slug: 'rexie', name: '热血', icon: 'ri-fire-fill', description: '燃到爆的热血战斗漫画', color: 'primary' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-3-fill', description: '甜蜜浪漫的恋爱故事', color: 'accent' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-fill', description: '充满想象力的奇幻世界', color: 'secondary' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-fill', description: '笑到停不下来的欢乐漫画', color: 'primary' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理漫画', color: 'accent' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-4-fill', description: '青春活力的校园漫画', color: 'secondary' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-fill', description: '现代都市中的精彩故事', color: 'primary' },
];

export const comics = [
  {
    id: 1,
    title: '绝世武魂',
    author: '天蚕土豆',
    category: 'guoman',
    tags: ['rexie', 'qihuan'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20style%2C%20martial%20arts%20warrior%20with%20glowing%20sword%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20orange%20tones%2C%20dramatic%20lighting%2C%20stylized%20anime%20art%2C%20clean%20composition%2C%20professional%20manga%20cover%20aesthetic%2C%20simple%20gradient%20background%2C%20high%20contrast%2C%20epic%20atmosphere&width=600&height=800&seq=comic-01&orientation=portrait',
    rating: 9.5,
    popularity: 98600,
    status: '连载中',
    chapters: 1280,
    description: '少年陈凡，偶得绝世传承，从此踏上逆天修行之路。在这片以武为尊的大陆上，且看他如何一步步崛起，成就无敌武魂，横扫八荒，问鼎巅峰！',
  },
  {
    id: 2,
    title: '某天成为公主',
    author: 'Plutus',
    category: 'hanman',
    tags: ['lianai', 'qihuan'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20style%2C%20beautiful%20princess%20in%20elegant%20dress%2C%20fantasy%20palace%20setting%2C%20soft%20pink%20and%20rose%20gold%20tones%2C%20delicate%20portrait%2C%20romantic%20atmosphere%2C%20stylized%20manhwa%20illustration%2C%20clean%20composition%2C%20simple%20warm%20background%2C%20professional%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-02&orientation=portrait',
    rating: 9.7,
    popularity: 125000,
    status: '已完结',
    chapters: 180,
    description: '一觉醒来，我竟然变成了小说里的公主——还是那个注定要被父亲处死的悲剧公主！为了活下去，我必须想尽办法讨好冷酷的皇帝父亲，可事情似乎朝着意想不到的方向发展了……',
  },
  {
    id: 3,
    title: '咒术回战',
    author: '芥见下下',
    category: 'riman',
    tags: ['rexie', 'qihuan'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%2C%20sorcerer%20character%20with%20dark%20energy%20effects%2C%20dynamic%20battle%20pose%2C%20warm%20amber%20and%20orange%20lighting%2C%20supernatural%20atmosphere%2C%20stylized%20shonen%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20manga%20cover%20aesthetic&width=600&height=800&seq=comic-03&orientation=portrait',
    rating: 9.3,
    popularity: 158000,
    status: '连载中',
    chapters: 262,
    description: '高中生虎杖悠仁偶然吞下诅咒之王的手指，从此踏入了咒术师的世界。在这个充满诅咒与战斗的世界里，他必须不断成长，与伙伴们一起对抗威胁人类的诅咒。',
  },
  {
    id: 4,
    title: '斗罗大陆',
    author: '唐家三少',
    category: 'guoman',
    tags: ['rexie', 'qihuan', 'lianai'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%2C%20young%20warrior%20with%20blue%20silver%20grass%20spirit%2C%20fantasy%20world%20setting%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20adventure%20atmosphere%2C%20stylized%20donghua%20art%20style%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover%20aesthetic&width=600&height=800&seq=comic-04&orientation=portrait',
    rating: 9.6,
    popularity: 210000,
    status: '连载中',
    chapters: 650,
    description: '唐门外门弟子唐三，因偷学内门绝学被逼跳崖明志，却意外穿越到斗罗大陆。在这片以武魂为尊的世界里，他凭借前世记忆与唐门绝学，一步步走向巅峰。',
  },
  {
    id: 5,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'hanman',
    tags: ['lianai', 'xiaoyuan', 'gaoxiao'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20school%20uniform%2C%20soft%20pink%20and%20peach%20tones%2C%20romantic%20comedy%20vibe%2C%20stylized%20manhwa%20art%2C%20clean%20composition%2C%20simple%20warm%20background%2C%20professional%20webtoon%20cover&width=600&height=800&seq=comic-05&orientation=portrait',
    rating: 9.4,
    popularity: 189000,
    status: '已完结',
    chapters: 230,
    description: '因为外貌被欺凌的平凡女孩，通过化妆技巧华丽变身成为校园女神。她小心翼翼地守护着自己的秘密，却遇到了两个完全不同的男生，一段爆笑又温馨的校园爱情故事就此展开。',
  },
  {
    id: 6,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'riman',
    tags: ['rexie', 'qihuan', 'xuanyi'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20illustration%2C%20demon%20slayer%20with%20nichirin%20sword%2C%20water%20breathing%20effects%2C%20warm%20sunset%20orange%20and%20amber%20tones%2C%20dynamic%20action%2C%20stylized%20shonen%20art%2C%20clean%20composition%2C%20simple%20dark%20gradient%20background%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-06&orientation=portrait',
    rating: 9.8,
    popularity: 245000,
    status: '已完结',
    chapters: 205,
    description: '大正时代，少年炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人的方法，他踏上了成为鬼杀队剑士的道路，与各种强大的鬼展开殊死搏斗。',
  },
  {
    id: 7,
    title: '全职高手',
    author: '蝴蝶蓝',
    category: 'guoman',
    tags: ['rexie', 'gaoxiao', 'dushi'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%2C%20esports%20player%20with%20gaming%20headset%2C%20cool%20cyberpunk%20elements%2C%20warm%20orange%20and%20golden%20neon%20accents%2C%20competitive%20atmosphere%2C%20stylized%20donghua%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-07&orientation=portrait',
    rating: 9.5,
    popularity: 176000,
    status: '已完结',
    chapters: 540,
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部驱逐。离开职业圈的他寄身于一家网吧，重新投入游戏，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
  },
  {
    id: 8,
    title: '我独自升级',
    author: 'Chugong',
    category: 'hanman',
    tags: ['rexie', 'qihuan', 'dushi'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%2C%20powerful%20hunter%20with%20dark%20shadow%20army%2C%20epic%20battle%20scene%2C%20warm%20amber%20and%20deep%20orange%20tones%2C%20intense%20atmosphere%2C%20stylized%20manhwa%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-08&orientation=portrait',
    rating: 9.9,
    popularity: 320000,
    status: '已完结',
    chapters: 200,
    description: '十年前，世界各地出现了连接异次元的"门"，部分人类觉醒了特殊能力成为"猎人"。被称为"人类最弱兵器"的E级猎人成振宇，在一次几乎全军覆没的副本任务中获得了神秘的"系统"，从此开始了独一无二的升级之路。',
  },
  {
    id: 9,
    title: '进击的巨人',
    author: '谏山创',
    category: 'riman',
    tags: ['rexie', 'xuanyi', 'qihuan'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%2C%20survey%20corps%20soldier%20with%20ODM%20gear%2C%20titan%20in%20background%2C%20dramatic%20warm%20orange%20sunset%20lighting%2C%20epic%20scale%2C%20stylized%20dark%20fantasy%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-09&orientation=portrait',
    rating: 9.7,
    popularity: 280000,
    status: '已完结',
    chapters: 139,
    description: '巨人支配的世界中，人类被逼到高墙内苟延残喘。少年艾伦·耶格尔目睹母亲被巨人吞噬，发誓要将巨人全部驱逐。他加入调查兵团，在一次次与巨人的战斗中，渐渐揭开了世界的残酷真相。',
  },
  {
    id: 10,
    title: '星辰变',
    author: '我吃西红柿',
    category: 'guoman',
    tags: ['qihuan', 'rexie'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%2C%20cultivator%20flying%20among%20stars%2C%20celestial%20energy%20effects%2C%20warm%20golden%20and%20cosmic%20orange%20tones%2C%20divine%20atmosphere%2C%20stylized%20xianxia%20art%2C%20clean%20composition%2C%20simple%20starry%20background%2C%20professional%20cover&width=600&height=800&seq=comic-10&orientation=portrait',
    rating: 9.3,
    popularity: 142000,
    status: '连载中',
    chapters: 980,
    description: '秦羽天生无法修炼内功，为了得到父亲的重视，他毅然选择修炼最痛苦艰难的外功。一次意外中，他得到了一颗流星泪，从此开启了星辰变的修炼之路，纵横三界，无敌于天下！',
  },
  {
    id: 11,
    title: '甜蜜的陷阱',
    author: '金秀晶',
    category: 'hanman',
    tags: ['lianai', 'dushi', 'xuanyi'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%2C%20elegant%20woman%20in%20office%20setting%2C%20romantic%20tension%2C%20soft%20rose%20and%20warm%20peach%20tones%2C%20dramatic%20romance%20atmosphere%2C%20stylized%20manhwa%20art%2C%20clean%20composition%2C%20simple%20warm%20background%2C%20professional%20cover&width=600&height=800&seq=comic-11&orientation=portrait',
    rating: 9.1,
    popularity: 87000,
    status: '连载中',
    chapters: 95,
    description: '职场精英林秀雅在事业巅峰时遭遇上司背叛，被迫离开公司。她决心复仇，却在过程中与对手公司的CEO展开了一段危险又迷人的爱情博弈。这场甜蜜的陷阱，究竟谁是猎物，谁是猎手？',
  },
  {
    id: 12,
    title: '排球少年',
    author: '古馆春一',
    category: 'riman',
    tags: ['rexie', 'xiaoyuan', 'gaoxiao'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%2C%20volleyball%20player%20jumping%20to%20spike%2C%20dynamic%20sports%20action%2C%20warm%20gymnasium%20orange%20lighting%2C%20energetic%20atmosphere%2C%20stylized%20sports%20manga%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-12&orientation=portrait',
    rating: 9.6,
    popularity: 198000,
    status: '已完结',
    chapters: 402,
    description: '矮个子少年日向翔阳，被排球赛场上"小巨人"的身姿所震撼，从此爱上了排球。进入高中后，他加入了乌野高中排球部，与天才二传手影山飞雄成为搭档，向着全国大赛的目标奋勇前进！',
  },
  {
    id: 13,
    title: '仙王的日常生活',
    author: '枯玄',
    category: 'guoman',
    tags: ['gaoxiao', 'qihuan', 'xiaoyuan'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20style%2C%20powerful%20immortal%20student%20in%20school%20uniform%2C%20humorous%20expression%2C%20warm%20golden%20and%20playful%20orange%20tones%2C%20lighthearted%20atmosphere%2C%20stylized%20donghua%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-13&orientation=portrait',
    rating: 9.2,
    popularity: 135000,
    status: '连载中',
    chapters: 720,
    description: '修真界最强仙王王令，为了体验普通人的生活，压制修为进入现代高中就读。本想低调过日子，却总是因为各种意外而暴露实力，引发一连串令人捧腹的搞笑事件。',
  },
  {
    id: 14,
    title: '重生之都市修仙',
    author: '十里剑神',
    category: 'guoman',
    tags: ['dushi', 'qihuan', 'rexie'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20urban%20fantasy%20style%2C%20cultivator%20in%20modern%20city%20with%20spiritual%20energy%2C%20contrast%20between%20ancient%20and%20modern%2C%20warm%20orange%20sunset%20cityscape%2C%20stylish%20composition%2C%20stylized%20donghua%20art%2C%20clean%20composition%2C%20professional%20cover&width=600&height=800&seq=comic-14&orientation=portrait',
    rating: 9.4,
    popularity: 168000,
    status: '连载中',
    chapters: 850,
    description: '渡劫期大修士陈凡陨落天劫，却重回五百年前的少年时代。这一世，他要弥补所有遗憾，让那些背叛他的人付出代价，登临诸天万界之巅！地球的灵气复苏，也因他而开启。',
  },
  {
    id: 15,
    title: '看脸时代',
    author: '朴泰俊',
    category: 'hanman',
    tags: ['dushi', 'xiaoyuan', 'rexie'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%2C%20high%20school%20student%20dual%20identity%20concept%2C%20transformation%20theme%2C%20warm%20amber%20street%20lighting%2C%20urban%20drama%20atmosphere%2C%20stylized%20manhwa%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-15&orientation=portrait',
    rating: 9.5,
    popularity: 201000,
    status: '连载中',
    chapters: 510,
    description: '因为外貌和身材被欺凌的胖学生朴玄硕，转学后意外发现自己拥有了两个身体——一个是原本肥胖的身体，一个则是完美的帅气身体。在两个身体之间切换的他，开始体验截然不同的校园生活。',
  },
  {
    id: 16,
    title: '葬送的芙莉莲',
    author: '山田钟人',
    category: 'riman',
    tags: ['qihuan', 'lianai'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%2C%20elf%20mage%20in%20peaceful%20journey%2C%20nostalgic%20fantasy%20setting%2C%20warm%20golden%20sunlight%20through%20trees%2C%20melancholic%20yet%20hopeful%20atmosphere%2C%20stylized%20fantasy%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-16&orientation=portrait',
    rating: 9.9,
    popularity: 256000,
    status: '连载中',
    chapters: 140,
    description: '打倒魔王的勇者一行人的后日谈。长生种精灵魔法使芙莉莲，在勇者辛美尔去世后才开始真正理解人类的感情。带着对逝去伙伴的思念，她踏上了"了解人类"的旅程，沿途收获了新的羁绊与感动。',
  },
  {
    id: 17,
    title: '大王饶命',
    author: '会说话的肘子',
    category: 'guoman',
    tags: ['gaoxiao', 'dushi', 'qihuan'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20style%2C%20mischievous%20teenager%20with%20supernatural%20powers%2C%20urban%20fantasy%2C%20warm%20golden%20and%20humorous%20orange%20tones%2C%20playful%20atmosphere%2C%20stylized%20donghua%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-17&orientation=portrait',
    rating: 9.2,
    popularity: 145000,
    status: '已完结',
    chapters: 480,
    description: '灵气复苏时代，吕树意外觉醒了依靠"负面情绪"来获取力量的异能。从此以后，他就走上了一条"让别人不开心我就开心"的修行之路。嘴上说着"大王饶命"，下手却比谁都狠！',
  },
  {
    id: 18,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'riman',
    tags: ['gaoxiao', 'dushi', 'lianai'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%2C%20spy%20family%20portrait%20with%20humorous%20and%20heartwarming%20vibe%2C%20retro%20european%20setting%2C%20warm%20amber%20and%20soft%20peach%20tones%2C%20comedy%20spy%20atmosphere%2C%20stylized%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-18&orientation=portrait',
    rating: 9.7,
    popularity: 235000,
    status: '连载中',
    chapters: 105,
    description: '为了执行秘密任务，顶级间谍"黄昏"需要组建一个临时家庭。他收养的女儿是会读心的超能力者，假结婚的妻子是职业杀手。三人互相隐藏身份，却在日常相处中产生了真正的家庭温暖。',
  },
  {
    id: 19,
    title: '社长的特别指示',
    author: 'LEEBORA',
    category: 'hanman',
    tags: ['lianai', 'dushi', 'gaoxiao'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20style%2C%20handsome%20CEO%20and%20office%20worker%20romantic%20moment%2C%20modern%20office%20setting%2C%20warm%20rose%20gold%20and%20soft%20peach%20tones%2C%20romantic%20comedy%20vibe%2C%20stylized%20manhwa%20art%2C%20clean%20composition%2C%20simple%20warm%20background%2C%20professional%20cover&width=600&height=800&seq=comic-19&orientation=portrait',
    rating: 9.0,
    popularity: 92000,
    status: '连载中',
    chapters: 67,
    description: '平凡上班族苏敏偶然发现了一个惊天秘密——新来的年轻社长竟然是她多年前在游戏中结过婚的网友！当她以为要被开除时，社长却下达了"特别指示"：继续当我的老婆，不过是现实版的。',
  },
  {
    id: 20,
    title: '完美世界',
    author: '辰东',
    category: 'guoman',
    tags: ['qihuan', 'rexie'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20fantasy%20style%2C%20young%20warrior%20with%20ancient%20primordial%20energy%2C%20vast%20fantasy%20world%2C%20warm%20golden%20sunrise%20and%20epic%20orange%20tones%2C%20grand%20atmosphere%2C%20stylized%20donghua%20art%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20professional%20cover&width=600&height=800&seq=comic-20&orientation=portrait',
    rating: 9.5,
    popularity: 189000,
    status: '连载中',
    chapters: 620,
    description: '一粒尘可填海，一根草斩尽日月星辰。石昊生而为至尊，却在大荒中被夺走至尊骨。他以凡体之身，逆天改命，在这片浩瀚的完美世界中，走出了一条独属于自己的无敌之路。',
  },
];

export const faqs = [
  {
    question: '新新漫画是什么类型的网站？',
    answer: '新新漫画是一个专注于漫画分类与推荐的导航平台，涵盖韩漫、日漫、国漫等多种类型的漫画资源。我们通过精细的分类系统和热门推荐，帮助漫画爱好者快速找到感兴趣的作品，无论是热血战斗、甜蜜恋爱还是悬疑推理，都能在这里找到心仪的漫画。',
  },
  {
    question: '新新漫画的漫画资源从哪里来？',
    answer: '新新漫画作为漫画导航和推荐平台，整理和收录了各大主流漫画平台的热门作品信息。我们提供详细的漫画介绍、分类标签和读者评价，方便用户快速了解漫画内容，选择适合自己的作品进行阅读。',
  },
  {
    question: '韩漫和日漫有什么区别？',
    answer: '韩漫（韩国漫画）通常采用全彩条漫格式，画面精美细腻，剧情节奏紧凑，恋爱、奇幻类题材尤为突出。日漫（日本漫画）则以黑白页漫为主，分镜表现力极强，题材覆盖面广，热血、悬疑、搞笑等类型作品丰富。两者各有特色，新新漫画为您提供全面的分类浏览体验。',
  },
  {
    question: '如何找到自己喜欢的漫画类型？',
    answer: '新新漫画提供了多种方式帮您找到心仪的漫画：您可以通过首页的热门推荐发现优质作品，也可以按类型分类（韩漫、日漫、国漫、热血、恋爱等）进行筛选浏览。每个漫画都有详细的标签和简介，帮助您快速判断是否符合自己的口味。',
  },
  {
    question: '新新漫画多久更新一次内容？',
    answer: '新新漫画团队持续关注漫画市场动态，定期更新热门漫画信息和推荐列表。我们会根据漫画的热度、评分和读者反馈，及时调整推荐内容，确保用户始终能够发现最新、最优质的漫画作品。',
  },
  {
    question: '如何收藏自己喜欢的漫画？',
    answer: '在新新漫画浏览时，您可以点击漫画详情页查看完整信息。我们建议您将喜欢的漫画页面加入浏览器书签收藏，或记录漫画名称以便随时查找。未来我们还将推出用户收藏夹功能，敬请期待！',
  },
];